import React from "react";
import "./IntroductionPage.css";

const IntroductionPage = () => {
  return (
    <div className="intro-container">
      <header className="about-header">
        <h1>E-Administration Chaman Presentation</h1>
        <p>Awesome Presentation</p>
      </header>
      <div
        id="1734674943449"
        style={{
          width: "100%",
          maxWidth: "1500px",
          height: "525px",
          margin: "auto",
          display: "block",
          position: "relative",
          border: "2px solid #dee1e5",
          borderRadius: "3px",
        }}
      >
        <iframe
          allow="clipboard-write"
          allowFullScreen
          style={{
            width: "100%",
            height: "100%",
            border: "none",
          }}
          src="https://app.presentations.ai/view/iP4bcl"
          scrolling="no"
        ></iframe>
      </div>
      <footer style={{ textAlign: "center", marginTop: "20px" }}>
        <p>© 2024 OurZest. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default IntroductionPage;
